'use client'

import { NotificationModel } from '@/core/types/models/notification.model'
import { create } from 'zustand'

type NotificationGuard = {
  canActivate: (notification: NotificationModel) => boolean
}

type NotificationObserver = {
  update: (notification: NotificationModel) => void
}

type PushNotificationsState = {
  guards: NotificationGuard[]
  observers: NotificationObserver[]

  addGuard: (guard: NotificationGuard) => void
  removeGuard: (guard: NotificationGuard) => void

  observe: (observer: NotificationObserver) => void
  unobserve: (observer: NotificationObserver) => void
}

export const usePushNotificationsStore = create<PushNotificationsState>(
  set => ({
    guards: [],
    observers: [],

    addGuard: guard => set(state => ({ guards: [...state.guards, guard] })),

    removeGuard: guard =>
      set(state => ({
        guards: state.guards.filter(g => g !== guard),
      })),

    observe: observer =>
      set(state => ({ observers: [...state.observers, observer] })),

    unobserve: observer =>
      set(state => ({
        observers: state.observers.filter(o => o !== observer),
      })),
  }),
)
